import { createSelector } from '@reduxjs/toolkit';

// Selector for getting all roles by Organization
export const selectRoles = createSelector(
	[(state) => state.Roles.data, (state) => state.Auth.selectedProfile.orgID],
	(rolesData, orgID) => rolesData?.[orgID] || []
);
